module.exports = __webpack_public_path__ + "static/media/gallery-2-11.7b03cc3c.jpg";